import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import {
  Answer,
  QuestionType,
  QuestionsResponse,
  SubmitAnswersResponse,
} from 'src/app/feature/onboarding-v2/models/question.model';
import { environment } from 'src/environments/environment';

/**
 * Endpoints del cuestionario "knowledge" expuestos a nivel de usuario logueado.
 *
 * Mismo contrato (`Question[]` / `Answer[]`) que `OnboardingV2Service.questions`,
 * pero las rutas viven bajo `/user/quiz/...` y se autentican con el token de
 * sesión (lo agrega el interceptor estándar). Se usa desde el flujo CU010
 * (modal Quiz cuando el usuario invitado intenta operar).
 */
@Injectable({ providedIn: 'root' })
export class UserQuizService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.baseUrl}user/quiz`;

  getQuestions(type: QuestionType): Observable<QuestionsResponse> {
    const params = new HttpParams().set('type', type);
    return this.http.get<QuestionsResponse>(`${this.baseUrl}/questions`, {
      params,
    });
  }

  submitAnswers(answers: Answer[]): Observable<SubmitAnswersResponse> {
    return this.http.post<SubmitAnswersResponse>(
      `${this.baseUrl}/answers`,
      { answers },
    );
  }
}
